import { Button, Form, message, Space, Table } from "antd";
import { useEffect, useState } from "react";
import { fmtDate } from "../../extensions/utils";
import FreezeModal from "./client-freeze-abon-modal";
import UnfreezeModal from "./client-unfreeze-abon-modal";
import ActivateModal from "./client-activate-abon-modal";
import CloseModal from "./client-close-abon-modal";
import ClientAbonStatusChange from "./client-abon-status-change";
import { DownOutlined, RightOutlined } from "@ant-design/icons";
import { salesStatuses, getTableColumn } from "../../extensions/helper";
import { serverFetch } from "../../server";
import { isMobile } from "../../extensions/design";
import ClientItemAbonStatus from "./client-item-abon-status";

const ClientAbonItemStatus = ({ id, onAbonsUpdate }) => {
  const [itmStatusList, setItmStatusList] = useState([]);
  const [loading, setLoading] = useState(false);
  const [freezeModalVisible, setFreezeModalVisible] = useState(false);
  const [unfreezeModalVisible, setUnfreezeModalVisible] = useState(false);
  const [activateModalVisible, setActivateModalVisible] = useState(false);
  const [closeModalVisible, setCloseModalVisible] = useState(false);
  const [abonStatus, setAbonStatus] = useState(false);
  const [itemAbon, setItemAbon] = useState([]);

  const [editId, setEditId] = useState();

  const getStatusData = () => {
    setLoading(true);
    serverFetch(`sale/${id}`)
      .then((abondata) => {
        setItemAbon(abondata);
        serverFetch(`sale/statusmovelist/${id}`)
          .then((data) => {
            setItmStatusList(data);
            setLoading(false);
            setAbonStatus(abondata.status);
          })
          .catch((e) => {
            setLoading(false);
            message.error(e.userMessage);
          });
      })
      .catch((e) => {
        setLoading(false);
        message.error(e.userMessage || "Ошибка загрузки");
      });
  };

  useEffect(() => {
    getStatusData();
  }, []);

  const onClose = (statusValue) => {
    setFreezeModalVisible(false);
    setUnfreezeModalVisible(false);
    setActivateModalVisible(false);
    setCloseModalVisible(false);

    if (statusValue) {onAbonsUpdate(); getStatusData();}
  };

  const onUpdateOnCloseFunction = () => {
    onAbonsUpdate();
    getStatusData();
    setEditId(null);
  }

  const statusColumns = [ 
    getTableColumn("docDate", "Дата", { type: "date", formatFn: fmtDate, width: 35 }, itmStatusList),
    getTableColumn("status", "Вид", { width: 40, valueList: salesStatuses.map((i) => ({ text: i.label, value: i.value })),
      render: (value) => salesStatuses.find((i) => i.value === value)?.label || value,
    }),
    getTableColumn("comment", "Комментарий", { width: 70 }, itmStatusList),
    /* getTableColumn("syma", "Сумма", { width: 30 }, itmStatusList), */
    getTableColumn("userName", "Пользователь", { width: 70 }, itmStatusList),
    /* getTableColumn("edit", "", { width: 16, sorter: false, render: (_, record) => (
        <img src="/images/edit.svg" alt="edit" onClick={() => { setChangeData(record); setChangeModalVisible(true); }} className="img-edit-btn"/>
      ),
    }),
    getTableColumn("delete", "", { width: 16, sorter: false, render: (_, record) => (
        <img src="/images/trashcan.svg" alt="delete" onClick={() => deleteStatus(record.id)} className="img-edit-btn"/>
      ),
    }), */
  ];
  
  const content = !isMobile ? 
    <> 
      {freezeModalVisible && <FreezeModal onClose={onClose} saleId={id}/>}
      {unfreezeModalVisible && <UnfreezeModal onClose={onClose} saleId={id}/>}
      {activateModalVisible && <ActivateModal onClose={onClose} saleId={id}/>}
      {closeModalVisible && <CloseModal onClose={onClose} saleId={id}/>}  

      <Form.Item><b>Статус</b></Form.Item>
      <Space style={{ marginBottom: "8px" }}>
        <Button className="sport-btn" disabled={!(abonStatus === 1 || abonStatus === 0)} onClick={() => setActivateModalVisible(true)}>Активировать</Button>
        <Button className="sport-btn" disabled={!(abonStatus === 2 && itemAbon.productVid === 2)} onClick={() => setFreezeModalVisible(true)}>Заморозить</Button>
        <Button className="sport-btn" disabled={!(abonStatus === 3 && itemAbon.productVid === 2)} onClick={() => setUnfreezeModalVisible(true)}>Разморозить</Button>
        <Button className="sport-btn" disabled={!(abonStatus === 2 || abonStatus === 3 || abonStatus === 4)} onClick={() => setCloseModalVisible(true)}>Закрыть</Button>
      </Space>
      <Table
        dataSource={itmStatusList}
        loading={loading}
        columns={statusColumns}
        rowKey="id"
        size="small"
        className="table-detail"
        pagination={false}
        rowClassName={(_, index) => (index % 2 === 0 ? "row-even" : "row-odd")}
        onRow={(record) => ({
          onClick: () => {
            const isExpanded = editId === record.id;
            setEditId(isExpanded ? null : record.id);
          },
        })}
        expandable={{
          expandedRowRender: (record) => editId === record.id ? (
          <ClientAbonStatusChange recordId={record.id}
            onUpdate={() => { onAbonsUpdate(); getStatusData(); setEditId(null);}}
            onClose={() =>  { onAbonsUpdate(); getStatusData(); setEditId(null);}}
            /> ) : null,
            expandedRowKeys: editId ? [editId] : [],
          onExpand: (expanded, record) => {
            setEditId(expanded ? record.id : null);
          },
          expandIcon: ({ expanded, onExpand, record }) =>
            expanded ? (
              <DownOutlined onClick={(e) => onExpand(record, e)} style={{ cursor: "pointer" }} />
            ) : (
              <RightOutlined onClick={(e) => onExpand(record, e)} style={{ cursor: "pointer" }} />
            ),
          expandIconColumnIndex: statusColumns.length,
          rowExpandable: () => true,
          className: "cl-abons-expandable",
        }}
      />
    </> : 
    <>
    <Form>
      <div className="client-items" style={{ overflowY: "scroll", overflowX: "clip"}}>
        {itmStatusList.map((item) => {
          const isExpanded = editId == item.id;
            return (
              <div key={item.id}>
                <div onClick={() => setEditId(isExpanded ? null : [item.id])} style={{ cursor: "pointer", border: "1px solid #d9d9d9", borderRadius: "8px"}}>
                  <ClientItemAbonStatus item={item} expanded={isExpanded} setExpanded={setEditId} onUpdateClose={onUpdateOnCloseFunction}/>
                </div>
              </div>
            );
          })}
          <div className="client-flexible-container-for-forms">
            <Button className="client-abon-item-status-button" disabled={!(abonStatus === 1 || abonStatus === 0)} onClick={() => setActivateModalVisible(true)}>Активир.</Button>
            <Button className="client-abon-item-status-button" disabled={!(abonStatus === 2 && itemAbon.productVid === 2)} onClick={() => setFreezeModalVisible(true)}>Замороз.</Button>
            <Button className="client-abon-item-status-button" disabled={!(abonStatus === 3 && itemAbon.productVid === 2)} onClick={() => setUnfreezeModalVisible(true)}>Размороз.</Button>
            <Button className="client-abon-item-status-button" disabled={!(abonStatus === 2 || abonStatus === 3 || abonStatus === 4)} onClick={() => setCloseModalVisible(true)}>Закрыть</Button>
          </div>
        </div>
    </Form>
    {freezeModalVisible && <FreezeModal onClose={onClose} saleId={id}/>}
    {unfreezeModalVisible && <UnfreezeModal onClose={onClose} saleId={id}/>}
    {activateModalVisible && <ActivateModal onClose={onClose} saleId={id}/>}
    {closeModalVisible && <CloseModal onClose={onClose} saleId={id}/>}  
  </>
  return (
    <>
      {content}
    </>
  );
};

export default ClientAbonItemStatus;
